import { useEffect, useMemo } from "react";
import { useLocation, useMatch, useOutlet, useParams, useResolvedPath } from "react-router-dom";
import theme, { getTenant } from "../../theme";
import Type1 from "../MobileHeaderTypes/Type1";
import Type2 from "../MobileHeaderTypes/Type2";
import Type3 from "../MobileHeaderTypes/Type3";
import { checkEmptyObj } from "../../utils";
import { useMediaQuery } from "@react-hook/media-query";
import { RootState } from "../../store";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

export default function MobileHeader() {
  const { t, i18n } = useTranslation("mobileHeader");
  const location = useLocation();
  const params = useParams();
  const tenant = getTenant();
  const mobile = useMediaQuery("only screen and (max-width: 600px)");
  const user = useSelector((state: RootState) => state.user);

  const headerTypes = useMemo(() => {
    const locationPath = location.pathname;
    const type0Routes = ["/join", "/recommended-plans", "/diet-preference"];
    const type1Routes = [
      "/login",
      "/profile",
      "/forgot-password",
      "/dietitian-appointment",
      "/contact",
      "/about",
      "/congrats",
      "/plans",
    ];
    const type2Routes = ["/partners", "/meal-plan"];
    let type3Routes: string[] = [];

    if (mobile && checkEmptyObj(user)) {
      type2Routes.push("/");
    } else {
      type3Routes.push("/");
    }

    return {
      type0: type0Routes.some((item) => locationPath === item),
      type1: type1Routes.some((item) => locationPath.indexOf(item) === 0),
      type2: type2Routes.some((item) => locationPath.indexOf(item) === 0),
      type3: type3Routes.some((item) => locationPath.indexOf(item) === 0),
    };
  }, [location, mobile, user]);

  const getRouteName = (route: string) => {
    const match = route.match(/\/\w+\//g);
    let routeName = "";
    if (match?.length) {
      let subroute = route.slice(match[0].length);
      routeName = match[0].slice(1, match[0].length - 1);
      if (subroute.length > 0) {
        routeName = subroute;
      }
    } else {
      routeName = route.slice(1);
    }
    routeName = routeName.replace(/-/g, "_");

    const routeKeyMap: Record<string, string> = {
      login: "login",
      profile: "profile",
      address: "address",
      forgot_password: "forgotPassword",
      dietitian_appointment: "dietitianAppointment",
      contact: "contact",
      about: "about",
      congrats: "healthAnalytics",
      partners: "recommendedPlans",
      meal_plan: "recommendedPlans",
      plans: "plans",
      health_analytics: "healthAnalytics",
      plan_info: "subscriptions",
      change_password: "changePassword",
      edit: "profile",
      wallet: "wallet",
    };

    const translationKey = routeKeyMap[routeName];
    return translationKey ? t(translationKey) : "";
  };

  useEffect(() => {
    let color = "";
    if (headerTypes.type1) {
      color = theme.palette.primary.main;
    }
    if (headerTypes.type2) {
      color = theme.palette.text.white;
    }
    //document.querySelector('meta[name="theme-color"]')?.setAttribute("content", color);
  }, [headerTypes]);

  if (headerTypes.type0) {
    return <></>;
  }

  if (headerTypes.type1) {
    let historyBack = location.pathname === "/congrats" ? false : true;
    return <Type1 historyBack={historyBack} title={getRouteName(location.pathname)} />;
  }

  if (headerTypes.type2) {
    return null;
  }

  if (headerTypes.type3) {
    return <Type3 />;
  }

  return <Type2 historyBack={true} />;
}
